import React, { useEffect, useState } from 'react';
import { getData, getDomain, insertData, insertDataJson, updateItem } from '../../Tools/helpers';
import Alert from "@mui/material/Alert";
import TablaStudentRegister from './TableStudentRegister';
import TablaStudentRegisterExcel from './TableStudentRegisterExcel';

const ModalStudentRegistration = ({ onClose, universityID }) => {
  const [generations, setGenerations] = useState([]);
  const [careers, setCareers] = useState([]);
  const [modes, setModes] = useState([]);
  const [activeTab, setActiveTab] = useState('individual');
  const [editStudent, setEditStudent] = useState(false);

  const EmtyForm = {
    generation_code: '',
    date_init: '',
    date_generation_init: '',
    date_generation_end: '',
    name: '',
    curp: '',
    email: '',
    career: '',
    mode: '',
    cost: '',
    status: 'Activo',
    justification: '',
    date_out: ''
  }

  const [formData, setFormData] = useState(EmtyForm);
  
  const [message, setMessage] = useState({
    status: false,
    message: "",
    label: "",
  });

  const [messageForm, setMessageForm] = useState({
    status: false,
    message: "",
    label: "",
  });

  const [studentsExcel, setStudentsExcel] = useState([]);
  const [students, setStudents] = useState([]);
  const [studentsFilter, setStudentsFilter] = useState([]);
  const [newGeneration, setNewGeneration] = useState({
    code: '',
    level: '',
    date_init: '',
    date_end: ''
  });

  // Manejar cambios en los inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if(name === "status" && value === "Activo"){
      setFormData(prev => ({
        ...prev,
        [name]: value,
        justification: '',
        date_out: ''
      }));
      return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

  };

  const filterGeneration = () => {
    let filtered = students;
  
    if (formData.generation_code) {
      filtered = filtered.filter(item => item.generation_code === formData.generation_code);
    }
  
    if (formData.career) {
      filtered = filtered.filter(item => item.career === formData.career);
    }
  
    setStudentsFilter(filtered);
  };
  
  useEffect(() => {
    filterGeneration();
  }, [formData.generation_code, formData.career]);

  // Manejar cambios para nueva generación
  const handleNewGenerationChange = (e) => {
    const { name, value } = e.target;
    setNewGeneration(prev => ({
      ...prev,
      [name]: value
    }));
  };


  // Manejar envío del formulario individual
  const handleIndividualSubmit = async (e) => {
    e.preventDefault();
    
    setMessageForm({
      status: false,
      message: "",
      label: "",
    });

    setMessageForm({
      status: true,
      message: "Guardando...",
      label: "info",
    });

    const newData = {
      ...formData,
      university_id: universityID
    }

    if(editStudent){
      handleIndividualSubmitEdit(newData);
      return;
    }

    const request = await insertDataJson('Franchise-Student-Individual', newData);
    if(request.code === 201){
      setStudentsExcel([])
      setNewGeneration({
        code: '',
        date_init: '',
        date_end: ''
      });
      setMessageForm({
        status: true,
        message: "Estudiantes registrados correctamente",
        label: "success",
      });
      setFormData(EmtyForm);
      getCodeGenerations();
      return;
    }

    if(request.status === "error"){
      setMessageForm({
        status: true,
        message: request.message,
        label: "error",
      });
      return;
    }
    
  };

  const handleIndividualSubmitEdit= async(newData) =>{
    console.log(newData)
    const request = await updateItem(`Franchise-Student/${newData.id}`, newData);
    if(request.code === 200){
      setStudentsExcel([])
      setNewGeneration({
        code: '',
        date_init: '',
        date_end: ''
      });
      setMessageForm({
        status: true,
        message: "Estudiantes registrados correctamente",
        label: "success",
      });
      setFormData(EmtyForm);
      getCodeGenerations();
      return;
    }

    if(request.status === "error"){
      setMessageForm({
        status: true,
        message: request.message,
        label: "error",
      });
      return;
    }
  }

  // Manejar envío del formulario masivo
  const handleMassiveSubmit = async (e) => {
    e.preventDefault();
    setMessage({
      status: false,
      message: "",
      label: "",
    });
    if (studentsExcel.length === 0) {
      setMessage({
        status: true,
        message: "Por favor cargue un archivo de excel",
        label: "warning",
      });
      return;
    }
    if (!newGeneration.code) {
      setMessage({
        status: true,
        message: "Por favor ingresa un código de generación",
        label: "warning",
      });
      return;
    }

    const newData = {
      newGeneration,
      university_id: universityID,
      students: studentsExcel
    }

    setMessage({
      status: true,
      message: "Guardando...",
      label: "info",
    });

    const request = await insertDataJson('Franchise-Student', newData);
    if(request.code === 201){
      setStudentsExcel([])
      setNewGeneration({
        code: '',
        date_init: '',
        date_end: ''
      });
      setMessage({
        status: true,
        message: "Estudiantes registrados correctamente",
        label: "success",
      });
      return;
    }

    if(request.status === "error"){
      setMessage({
        status: true,
        message: request.message,
        label: "error",
      });
      return;
    }

  };

  // Manejar cambio de archivo Excel
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setMessage({
      status: true,
      message: "Cargando excel...",
      label: "info",
    });
    if (file && file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      const newData = new FormData();
      newData.append('file-excel-student', file);
      const request = await insertData('UploadExcelStudent', newData);
      if(request.code === 201){
        setStudentsExcel(request.data)
        setMessage({
          status: false,
          message: null,
          label: null,
        });
        return;
      }
      setMessage({
        status: true,
        message: "No se pudo cargar el archivo",
        label: "error",
      });
    } else {
      alert('Por favor selecciona un archivo Excel válido (.xlsx)');
    }
  };

  const selectedEditStudent = (student) =>{
    setFormData(student);
    setEditStudent(true);
  }

  const getCodeGenerations = async () => {
    const route = 'ListCatalogsCareer';
    const send = await getData(`${route}/${universityID}`);
    if (send.code === 200) {
      setStudents(send.data?.students ?? []);
      setStudentsFilter(send.data?.students ?? []);
      setGenerations(send.data?.codes ?? []);
      setCareers(send.data?.careers ?? []);
      setModes(send.data?.modes ?? []);
    }
  };

  useEffect(() => {
    getCodeGenerations();
  }, [universityID]);

  const fieldStyle = {
    width: '100%',
    padding: '8px 10px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '0.83rem',
    color: '#111827',
    outline: 'none',
    backgroundColor: '#fff',
    transition: 'border-color 0.15s',
    marginTop: '4px',
  };
  const labelStyle = {
    display: 'block',
    fontSize: '0.72rem',
    fontWeight: 600,
    color: '#374151',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  };
  const focusIn = (e) => { e.target.style.borderColor = '#dc2626'; e.target.style.boxShadow = '0 0 0 2px rgba(220,38,38,0.1)'; };
  const focusOut = (e) => { e.target.style.borderColor = '#d1d5db'; e.target.style.boxShadow = 'none'; };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50">
      <div style={{ background: '#fff', borderRadius: '10px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', width: '100%', maxWidth: '900px', maxHeight: '90vh', overflow: 'auto', display: 'flex', flexDirection: 'column' }}>

        {/* Modal header */}
        <div style={{ backgroundColor: '#111827', padding: '16px 24px', borderRadius: '10px 10px 0 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <i className="fa-solid fa-user-graduate" style={{ fontSize: '14px', color: '#fff' }}></i>
            </div>
            <span style={{ fontSize: '0.95rem', fontWeight: 700, color: '#f9fafb' }}>Registro de Alumnos</span>
          </div>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: '18px', lineHeight: 1, padding: '4px' }}
            onMouseEnter={e => e.currentTarget.style.color = '#f9fafb'}
            onMouseLeave={e => e.currentTarget.style.color = '#9ca3af'}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        {/* Tabs */}
        <div style={{ backgroundColor: '#1f2937', padding: '0 24px', display: 'flex', gap: '2px', flexShrink: 0 }}>
          {[
            { id: 'individual', label: 'Registro Individual', icon: 'fa-solid fa-user-plus' },
            { id: 'massive', label: 'Carga Masiva', icon: 'fa-solid fa-file-excel' },
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '6px',
                padding: '10px 18px', border: 'none', cursor: 'pointer',
                fontSize: '0.75rem', fontWeight: 600,
                backgroundColor: activeTab === tab.id ? '#dc2626' : 'transparent',
                color: activeTab === tab.id ? '#fff' : '#9ca3af',
                borderRadius: '0', transition: 'all 0.15s',
              }}
            >
              <i className={tab.icon} style={{ fontSize: '11px' }}></i>
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div style={{ padding: '24px', overflowY: 'auto' }}>

          {activeTab === 'individual' ? (
            <>
              <form onSubmit={handleIndividualSubmit}>
                {/* Section heading */}
                <div style={{ borderLeft: '4px solid #dc2626', paddingLeft: '10px', marginBottom: '16px' }}>
                  <span style={{ fontSize: '0.75rem', fontWeight: 700, color: '#111827', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    {editStudent ? 'Editar Alumno' : 'Datos del Alumno'}
                  </span>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2" style={{ gap: '14px', marginBottom: '16px' }}>
                  <div>
                    <label style={labelStyle}>Generación *</label>
                    <select name="generation_code" value={formData.generation_code} onChange={handleInputChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required>
                      <option value="">Selecciona una generación</option>
                      {generations.map(gen => <option key={gen} value={gen}>{gen}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Carrera *</label>
                    <select name="career" value={formData.career} onChange={handleInputChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required>
                      <option value="">Selecciona una carrera</option>
                      {careers?.map(item => <option key={item.career} value={item.career}>{item.career}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Nombre completo *</label>
                    <input type="text" name="name" value={formData.name} onChange={handleInputChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required />
                  </div>
                  <div>
                    <label style={labelStyle}>CURP *</label>
                    <input type="text" name="curp" value={formData.curp} onChange={handleInputChange} style={{ ...fieldStyle, fontFamily: 'monospace', textTransform: 'uppercase' }} onFocus={focusIn} onBlur={focusOut} required />
                  </div>
                  <div>
                    <label style={labelStyle}>Email</label>
                    <input type="email" name="email" value={formData.email} onChange={handleInputChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} />
                  </div>
                  <div>
                    <label style={labelStyle}>Modalidad *</label>
                    <select name="mode" value={formData.mode} onChange={handleInputChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required>
                      <option value="">Selecciona una modalidad</option>
                      {modes.map(mode => <option key={mode} value={mode}>{mode}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Fecha de Ingreso *</label>
                    <input type="date" name="date_init" value={formData.date_init} onChange={handleInputChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required />
                  </div>
                  <div>
                    <label style={labelStyle}>Colegiatura *</label>
                    <input type="number" name="cost" value={formData.cost} onChange={handleInputChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required />
                  </div>
                  <div>
                    <label style={labelStyle}>Inicio Generación</label>
                    <input type="date" name="date_generation_init" value={formData.date_generation_init} onChange={handleInputChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required />
                  </div>
                  <div>
                    <label style={labelStyle}>Término Generación</label>
                    <input type="date" name="date_generation_end" value={formData.date_generation_end} onChange={handleInputChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required />
                  </div>
                  <div>
                    <label style={labelStyle}>Estado *</label>
                    <select name="status" value={formData.status} onChange={handleInputChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required>
                      <option value="Activo">Activo</option>
                      <option value="Baja">Baja</option>
                    </select>
                  </div>
                  {formData.status === 'Baja' && (
                    <>
                      <div>
                        <label style={labelStyle}>Justificación de baja *</label>
                        <textarea name="justification" value={formData.justification} onChange={handleInputChange} style={{ ...fieldStyle, resize: 'vertical', minHeight: '72px' }} onFocus={focusIn} onBlur={focusOut} required />
                      </div>
                      <div>
                        <label style={labelStyle}>Fecha Baja *</label>
                        <input type="date" name="date_out" value={formData.date_out} onChange={handleInputChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required />
                      </div>
                    </>
                  )}
                </div>

                {messageForm.status && <Alert className="mb-3" severity={messageForm.label}>{messageForm.message}</Alert>}

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <button
                    type="submit"
                    style={{
                      display: 'inline-flex', alignItems: 'center', gap: '7px',
                      backgroundColor: editStudent ? '#d97706' : '#111827',
                      color: '#fff', border: 'none', borderRadius: '6px',
                      padding: '9px 22px', fontSize: '0.78rem', fontWeight: 700,
                      textTransform: 'uppercase', letterSpacing: '0.05em', cursor: 'pointer',
                    }}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#dc2626'}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = editStudent ? '#d97706' : '#111827'}
                  >
                    <i className={`fa-solid ${editStudent ? 'fa-pen-to-square' : 'fa-user-plus'}`} style={{ fontSize: '11px' }}></i>
                    {editStudent ? 'Actualizar Alumno' : 'Registrar Alumno'}
                  </button>
                </div>
              </form>

              <div style={{ marginTop: '24px', borderTop: '1px solid #e2e8f0', paddingTop: '20px' }}>
                <div style={{ borderLeft: '4px solid #dc2626', paddingLeft: '10px', marginBottom: '14px' }}>
                  <span style={{ fontSize: '0.75rem', fontWeight: 700, color: '#111827', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Alumnos Registrados</span>
                </div>
                <TablaStudentRegister students={studentsFilter} selectedEditStudent={selectedEditStudent} edit={true} />
              </div>
            </>
          ) : (
            <>
              <form onSubmit={handleMassiveSubmit}>

                {/* Step 1: File upload */}
                <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '20px', marginBottom: '16px' }}>
                  <div style={{ borderLeft: '4px solid #dc2626', paddingLeft: '10px', marginBottom: '14px' }}>
                    <span style={{ fontSize: '0.75rem', fontWeight: 700, color: '#111827', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                      Paso 1 — Seleccionar archivo Excel
                    </span>
                  </div>

                  <div style={{ border: '2px dashed #d1d5db', borderRadius: '8px', padding: '20px', backgroundColor: '#fff', display: 'flex', alignItems: 'center', gap: '14px' }}>
                    <div style={{ width: '44px', height: '44px', borderRadius: '8px', backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <i className="fa-solid fa-file-excel" style={{ fontSize: '20px', color: '#16a34a' }}></i>
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '0.83rem', fontWeight: 600, color: '#111827', marginBottom: '2px' }}>
                        {studentsExcel.length > 0
                          ? <span style={{ color: '#16a34a' }}><i className="fa-solid fa-circle-check" style={{ marginRight: '6px' }}></i>{studentsExcel.length} alumnos cargados</span>
                          : 'Ningún archivo seleccionado'
                        }
                      </div>
                      <div style={{ fontSize: '0.72rem', color: '#6b7280' }}>Columnas requeridas: Nombre, CURP, Email, Carrera, Modalidad</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                      <a
                        href={`${getDomain()}/template_alumnos_franquicias.xlsx`}
                        style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 12px', borderRadius: '5px', border: '1px solid #d1d5db', backgroundColor: '#f8fafc', color: '#374151', fontSize: '0.72rem', fontWeight: 600, textDecoration: 'none' }}
                      >
                        <i className="fa-solid fa-download" style={{ fontSize: '10px' }}></i>
                        Formato
                      </a>
                      <label style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 12px', borderRadius: '5px', border: '1px solid #374151', backgroundColor: '#111827', color: '#fff', fontSize: '0.72rem', fontWeight: 600, cursor: 'pointer' }}>
                        <i className="fa-solid fa-upload" style={{ fontSize: '10px' }}></i>
                        Cargar .xlsx
                        <input type="file" accept=".xlsx" onChange={handleFileChange} style={{ display: 'none' }} />
                      </label>
                    </div>
                  </div>
                </div>

                {/* Step 2: Generation data */}
                <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '20px', marginBottom: '16px' }}>
                  <div style={{ borderLeft: '4px solid #dc2626', paddingLeft: '10px', marginBottom: '14px' }}>
                    <span style={{ fontSize: '0.75rem', fontWeight: 700, color: '#111827', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                      Paso 2 — Datos de la Generación
                    </span>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-4" style={{ gap: '14px' }}>
                    <div>
                      <label style={labelStyle}>Código *</label>
                      <input type="text" name="code" value={newGeneration.code} onChange={handleNewGenerationChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} placeholder="Ej: G14" required />
                    </div>
                    <div>
                      <label style={labelStyle}>Nivel Educativo *</label>
                      <select name="level" value={newGeneration.level} onChange={handleNewGenerationChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required>
                        <option value="">Selecciona</option>
                        <option value="Licenciatura">Licenciatura</option>
                        <option value="Ingenieria">Ingeniería</option>
                        <option value="Maestria">Maestría</option>
                        <option value="Doctorado">Doctorado</option>
                        <option value="Salud">Salud</option>
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>Fecha Inicio *</label>
                      <input type="date" name="date_init" value={newGeneration.date_init} onChange={handleNewGenerationChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required />
                    </div>
                    <div>
                      <label style={labelStyle}>Fecha Término *</label>
                      <input type="date" name="date_end" value={newGeneration.date_end} onChange={handleNewGenerationChange} style={fieldStyle} onFocus={focusIn} onBlur={focusOut} required />
                    </div>
                  </div>
                </div>

                {message.status && <Alert className="mb-3" severity={message.label}>{message.message}</Alert>}

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '24px' }}>
                  <button
                    type="submit"
                    style={{
                      display: 'inline-flex', alignItems: 'center', gap: '7px',
                      backgroundColor: '#111827', color: '#fff', border: 'none',
                      borderRadius: '6px', padding: '9px 22px', fontSize: '0.78rem',
                      fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', cursor: 'pointer',
                    }}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#dc2626'}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = '#111827'}
                  >
                    <i className="fa-solid fa-floppy-disk" style={{ fontSize: '11px' }}></i>
                    Guardar Estudiantes
                  </button>
                </div>
              </form>

              {/* Generaciones existentes */}
              {generations.length > 0 && (
                <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '20px', marginBottom: '16px' }}>
                  <div style={{ borderLeft: '4px solid #dc2626', paddingLeft: '10px', marginBottom: '14px' }}>
                    <span style={{ fontSize: '0.75rem', fontWeight: 700, color: '#111827', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Generaciones Existentes</span>
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4" style={{ gap: '10px' }}>
                    {generations.map(gen => {
                      const count = students.filter(s => s.generation_code === gen).length;
                      return (
                        <div key={gen} style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '7px', padding: '12px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div>
                            <div style={{ fontSize: '0.82rem', fontWeight: 700, color: '#111827' }}>{gen}</div>
                            <div style={{ fontSize: '0.68rem', color: '#6b7280', marginTop: '2px' }}>{count} alumnos</div>
                          </div>
                          <span style={{ backgroundColor: '#111827', color: '#fff', borderRadius: '9999px', fontSize: '0.68rem', fontWeight: 700, padding: '2px 8px', minWidth: '24px', textAlign: 'center' }}>{count}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              <TablaStudentRegisterExcel students={studentsExcel} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalStudentRegistration;